import { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface EditSingleJobDialogProps {
  isOpen: boolean;
  onClose: () => void;
  jobName: string;
  currentHours: number;
  onConfirm: (hours: number) => void;
}

export function EditSingleJobDialog({
  isOpen,
  onClose,
  jobName,
  currentHours,
  onConfirm,
}: EditSingleJobDialogProps) {
  const [hours, setHours] = useState<string>(currentHours.toString());

  useEffect(() => {
    if (isOpen) {
      setHours(currentHours.toString());
    }
  }, [isOpen, currentHours]);

  const handleConfirm = () => {
    const parsedHours = parseFloat(hours);
    if (isNaN(parsedHours) || parsedHours <= 0) {
      return;
    }
    onConfirm(parsedHours);
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Edit Job</DialogTitle>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label className="text-muted-foreground">Job</Label>
            <p className="font-medium">{jobName}</p>
          </div>

          <div className="space-y-2">
            <Label htmlFor="edit-job-hours">Hours</Label>
            <Input
              id="edit-job-hours"
              type="number"
              step="0.1"
              min="0.1"
              value={hours}
              onChange={(e) => setHours(e.target.value)}
              placeholder="Enter hours"
            />
          </div>
        </div>

        <DialogFooter className="gap-2 sm:gap-0">
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={handleConfirm}>
            Confirm
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
